<template>
  <div class="app-container">
    <TopBar />
    <div :class="contentClasses">
      <router-view />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import TopBar from "./components/TopBar.vue";
import { useBreadcrumbsStore } from "./stores/breadcrumbs";

export default defineComponent({
  name: "App",
  components: {
    TopBar,
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const breadcrumbsStore = useBreadcrumbsStore();
    
    // Initialiser les breadcrumbs avec la route actuelle
    onMounted(() => {
      breadcrumbsStore.initializeBreadcrumbs(route);
    });
    
    // Écouter les changements de route pour mettre à jour les breadcrumbs
    router.afterEach((to) => {
      breadcrumbsStore.addCrumb(to);
    });
    
    // Classes conditionnelles pour le contenu
    const contentClasses = computed(() => {
      const isHomePage = route.name === 'Anamnesis';
      
      if (isHomePage) {
        // Pour la page d'accueil : pas de padding, pleine largeur
        return 'content-home pt-16';
      } else {
        // Pour les autres pages : padding normal
        return 'content pt-16 px-4 pb-4';
      }
    });
    
    return {
      contentClasses
    };
  }
});
</script>

<style>
html, body {
  margin: 0;
  padding: 0;
  height: 100%;
  background-color: #f9fafb;
}

.app-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.content {
  flex: 1;
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 4rem 1rem 1rem;
}

.content-home {
  flex: 1;
  width: 100%;
  margin: 0;
  padding: 0;
}

@media (max-width: 768px) {
  .content {
    padding: 5rem 0.75rem 1rem;
    width: calc(100% - 1.5rem);
  }
}

@media (max-width: 600px) {
  .content {
    padding: 5rem 0.5rem 1rem;
    width: calc(100% - 1rem);
    max-width: 100%;
  }
}
</style>